import React from "react"
import SavviFinancialIcon from "../Icons/savvi-financial-logo.svg"
import { useHistory } from "react-router"

const Logo = props => {
  const history = useHistory()
  const goHome = () => history.push("/home")
  return (
    <img
      src={SavviFinancialIcon}
      alt=""
      {...props}
      style={{ cursor: "pointer" }}
      onClick={goHome}
    />
  )
}

export default Logo
